import type { SegmentedWord } from "../segmenting/segmented-words.js";

/**
 * The line above the word list.
 *
 * Its own module beside the rows because it answers a different question from
 * any of them. A row is about one word and this is about the text: how much of
 * it there is, and how much of it is repetition.
 */

/**
 * What the summary line says above the list.
 *
 * Two numbers rather than one, because they answer different questions and a
 * reader deciding whether a text is worth their evening wants both. 3,000
 * words made of 700 distinct ones is a very different afternoon from 3,000
 * made of 2,000.
 */
export function summaryText(
  words: readonly SegmentedWord[],
  total: number,
): string {
  if (words.length === 0) {
    return "";
  }

  const distinct =
    words.length === 1
      ? "1 distinct word"
      : `${words.length.toLocaleString()} distinct words`;

  return `${total.toLocaleString()} ${total === 1 ? "word" : "words"}, ${distinct}.`;
}
